import { Box, Paper, Stack, Table, TableContainer, TableRow, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import { TableBody, TableHead } from 'mui-datatables';
import { createMessage } from './createMessage';

export const finalMessage = (
  <>
    <b>Congratulations on completing the GIFT application form! 🎉</b>
    <br />
    Here's what you can do next:
    <br />
    <li>Preview: You can see a preview of your responses on the right panel.</li>
    <li>Edit Responses: If you need to make any changes, feel free to edit your </li>
    <li>Save Changes: Be sure to save any changes you make.</li>
    <li>Submit: Once everything looks good, go ahead and submit your application.</li>
    <b>
      Thank you for your time and effort. If you have any further questions or need assistance, please don't hesitate to
      reach out.
      <br />
      Have a great day!
    </b>
  </>
);

export const greetingMessage = (
  <Typography sx={{ fontSize: variants.BODY }}>
    Hello! I'm here to assist you with the GIFT application process. Before we begin, let's go over some important
    guidelines to help you navigate smoothly:
  </Typography>
);

export const rules = (
  <>
    <Typography sx={{ fontSize: variants.BODY }}>
      1. To start the GIFT application, please press <b>"start"</b> button.
    </Typography>
    <Typography sx={{ fontSize: variants.BODY }}>
      2. Each question will present you with three options: <b>Yes</b>, <b>No</b>, and <b>Not applicable</b>.
    </Typography>

    <Typography sx={{ fontSize: variants.BODY }}>
      3. Please select the most appropriate option. If you choose <b>Yes</b>, you'll be prompted to provide a suitable
      reason.
    </Typography>
  </>
);

export const notEligible = message => {
  return (
    <>
      <Typography sx={{ fontSize: variants.BODY }}>Sorry you cannot apply, you are not eligible.</Typography>

      <Typography sx={{ fontSize: variants.BODY, fontWeight: 700 }}>{message}</Typography>
    </>
  );
};

export const kraTable = kra => {
  return kra.map((obj, index) =>
    createMessage(
      <Stack key={index} sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: variants.BODY, fontWeight: 600 }}>{obj.title}</Typography>
        {obj.questions.map((question, index) => {
          return (
            <Typography component={'li'} key={index} sx={{ fontSize: variants.BODY }}>
              {question}{' '}
            </Typography>
          );
        })}
      </Stack>
    )
  );
};
